import videojs from "video.js";
import {version as playerVersion} from "@package.json";

const Component = videojs.getComponent("Component");
const MenuItem = videojs.getComponent("MenuItem");

/**
 * The base class for buttons
 *
 * @param {Player|Object} player
 * @param {Object=} options
 * @extends MenuItem
 * @class ReleaseNotesMenuItem
 */
class ReleaseNotesMenuItem extends MenuItem
{
	handleClick()
	{
		super.handleClick();

		// Open the new window
		window.open(
			// TODO: I don't like how the release notes are currently handled
			// TODO: We have to manually update a markdown file, then parse that
			// TODO: markdown file to generate HTML, then upload that HTML
			// TODO: somewhere. This can't be tested locally, and it adds more
			// TODO: points of failure to our build system (which must now
			// TODO: handle the parsing of markdown). I'd prefer to pull these
			// TODO: programmatically from something like:
			// TODO: https://bitbucket.org/blueframetech/bfwebplayer/addon/pipelines/deployments
			`https://blueframe-player-flash.s3.amazonaws.com/v${playerVersion}/RELEASENOTES.html`,
			"_blank",
			"width=640,height=360"
		);
	}

	/**
	 * Builds the default DOM `className`.
	 *
	 * @return {string}
	 *		The DOM `className` for this object.
	 */
	buildCSSClass()
	{
		// ! For some stupid reason, VideoJS doesn't seem to call this method?
		return `vjs-release-notes-menu-item ${super.buildCSSClass()}`;
	}
}

/**
 * The text for this MenuItem Added for localization.
 *
 * @type {string}
 * @private
 */
ReleaseNotesMenuItem.prototype.options_ = {label: "Release Notes"};

Component.registerComponent("releaseNotesMenuItem", ReleaseNotesMenuItem);

export default ReleaseNotesMenuItem;
